import {
  Card,
  Layout,
  Page,
  Toast,
  Button,
  BlockStack,
  Box,
  Text,
  Icon
} from "@shopify/polaris";
import {
  CollectionsFilledMajor,
  InventoryMajor,
  ColorNoneMinor,
  MonerisMajor
} from '@shopify/polaris-icons';
import React, { useEffect, useState } from "react";
import LazyLoad from "react-lazyload";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
// import AppBridge from "../../../../utils/appBridge";
import utils from '../../../../utils/utils'
import intl from '../../../../i18n/intl';
import AppBridge from "../../../../utils/appBridge";
const SubscriptionPaidClass = () => {
 const router = useHistory();
 useEffect(() => {
  if(AppBridge && AppBridge.exist()) {
    AppBridge.setTitleBar('Custom Service')
  }
  // setPageTitle('Custom Service');
}, []);
// const setPageTitle = (title) => {
//   AppBridge.setTitleBar(title,'',props.saveData,props.loading,props.disabled)
// }
const data = [
  {
    title:intl.get('Branding'),
    dsc:intl.get('Custom brand packaging, labels, and cards.'),
    image:'/buildShopify/branding.png',
    level:false,
    icon:CollectionsFilledMajor,
    url:'/admin/customService/custom-packaging'
  },
  {
    title:intl.get('Private Storage'),
    dsc:intl.get('Private warehouse for advanced stocking, fast shipping.'),
    image:'/buildShopify/private_storage.png',
    level:true,
    levelImage:'/buildShopify/level.png',
    icon:InventoryMajor,
    url:'/admin/customService/inventory'
  },
  {
    title:intl.get('Print on demand'),
    dsc:intl.get('Design and customize products online, build your brand.'),
    image:'/buildShopify/POD.png',
    level:false,
    icon:ColorNoneMinor,
    url:'/admin/customService/print-on-demand?source=DSM'
  },
  {
    title:intl.get('Freight Calculation'),
    dsc:intl.get('Easy access to shipping routes, times, and costs.'),
    image:'/buildShopify/Freight_Calculation.png',
    level:false,
    icon:MonerisMajor,
    url:'/admin/customService/calculate-shipping'
  },
]
  const [showToast, setShowToast] = useState(false);
  const [showToastText, setShowToastText] = useState("");
  const [showToastIserror, setShowToastIserror] = useState(false);
  
  //提示弹窗
  const toggleToast = (showToastText, showToastIserror = false) => {
    setShowToast(!showToast);
    setShowToastText(showToastText);
    setShowToastIserror(showToastIserror);
  };
  const toastMarkup = showToast ? (
    <Toast
      content={showToastText}
      onDismiss={() => toggleToast("")}
      error={showToastIserror}
    />
  ) : null;
  
  const pageContent = (
    <Page
      // breadcrumbs={[{ onAction: () => history.push("/admin/dashboard") }]}
      title={AppBridge.exist() ? "" : intl.get("Custom Service")}
      fullWidth={false}
    >
      <Layout>
        <Layout.Section>
          <Box className='col_content'>
          <BlockStack gap={400}>
          {data.map((item,ind)=>
          <Card key={ind}>
            <Box className='col_box'>
          <Box className='col_box_left'>
          <Box className='col_box_left_top'>
            <span className="col_box_left_top_icon">
            <Icon
            source={item.icon}
            tone="base"
          />
          </span>
            <Text variant="headingMd" as="h6">
            {item.title}
          </Text>
          {item.level && <span className="col_box_left_top_level">
            <img src={item.levelImage} alt="level" />
            {intl.get("PRO")}
            </span>}
          </Box>
          <Text as="h6" variant="bodyMd">
        {item.dsc}
      </Text>
      <Button onClick={()=>{
        utils.routeListen(item.url)
        utils.routeJump1(router,item.url)
        }}>{intl.get("View More")}</Button>
          </Box>
          <Box className='col_box_right'>
          <LazyLoad once>
            <img src={item.image} alt="dropshipman" />
          </LazyLoad>
          </Box>
          </Box>
        </Card>)}
          </BlockStack>
          </Box>
        </Layout.Section>
      </Layout>
    </Page>
  );
  return (
    <div>
      {pageContent}
      {/* 提示 */}
      {toastMarkup}
    </div>
  );
};



export default SubscriptionPaidClass;
